import { FeeGroupEnum } from "../../models/fee-groupings/fee-groupings.model";

/*
 * I hate everything in this file and it should be deleted, but
 * the code attached to it is such a clusterfuck of bad decisions
 * that I can't do that in confidence because I have no idea what
 * it's doing
 */

export interface TextDiv {
    el: Element;
    selected: boolean;
}

export interface PageTextDiv {
    page: number;
    textDivs: TextDiv[];
}

export interface SelectedLine {
    pg: number;
    startTd: number;
    selCnt: number;
}

export class ClassifySelectionResult {
    position: number;
    optionSelected: boolean;
    feeLabel: string;
    feeProgram: string | null;
    feeAmount: number;
    feeGroup: FeeGroupEnum;
    isFlagged: boolean;
    htmlElements: HTMLElement[];
    feeId?: string;

    constructor(x: Partial<ClassifySelectionResult>) {
        this.position = x.position ?? 0;
        this.optionSelected = x.optionSelected ?? false;
        this.feeLabel = x.feeLabel ?? '';
        this.feeProgram = x.feeProgram ?? null;
        this.feeAmount = x.feeAmount ?? 0;
        this.feeGroup = x.feeGroup ?? FeeGroupEnum.INTERCHANGE;
        this.isFlagged = x.isFlagged ?? false;
        this.htmlElements = x.htmlElements ?? [];
        this.feeId = x.feeId ?? '';
    }
}
